/**
 * Сведения о продукте на стороне клиента.
 *
 * Единственный источник данных — публичный ответ GET /api/status backend'а,
 * который, в свою очередь, формируется пакетом api/product (переменные окружения SHB_*).
 * Компоненты не должны хранить название продукта, компании или версию в своем коде.
 */

export interface ProductInfo {
  name: string;
  company: string;
  description: string;
  version: string;
  buildNumber: string;
  buildDate: string;
  gitCommit: string;
  environment: string;
  instanceId: string;
  supportEmail: string;
  companyUrl: string;
}

/** Значения до получения ответа сервера (совпадают с DefaultName/DefaultCompany пакета api/product). */
export const DEFAULT_PRODUCT: ProductInfo = {
  name: 'ShbDeployer',
  company: 'ООО «СервисХаб»',
  description:
    'ShbDeployer — платформа для развертывания и хостинга приложений, которая позволяет разработчикам быстро и легко публиковать свои приложения в интернете.',
  version: '',
  buildNumber: '',
  buildDate: '',
  gitCommit: '',
  environment: '',
  instanceId: '',
  supportEmail: '',
  companyUrl: '',
};

let current: ProductInfo = { ...DEFAULT_PRODUCT };

/** Ответ GET /api/status (поля backend'а в PascalCase). */
export interface StatusResponse {
  Version?: string;
  BuildNumber?: string;
  BuildDate?: string;
  GitCommit?: string;
  ProductName?: string;
  CompanyName?: string;
  ProductDescription?: string;
  Environment?: string;
  InstanceID?: string;
  SupportEmail?: string;
  CompanyURL?: string;
}

export function productFromStatus(status: StatusResponse): ProductInfo {
  return {
    name: status.ProductName || DEFAULT_PRODUCT.name,
    company: status.CompanyName || DEFAULT_PRODUCT.company,
    description: status.ProductDescription || DEFAULT_PRODUCT.description,
    version: status.Version || '',
    buildNumber: status.BuildNumber || '',
    buildDate: status.BuildDate || '',
    gitCommit: status.GitCommit || '',
    environment: status.Environment || '',
    instanceId: status.InstanceID || '',
    supportEmail: status.SupportEmail || '',
    companyUrl: status.CompanyURL || '',
  };
}

export function setProductInfo(info: Partial<ProductInfo>) {
  current = { ...current, ...info };
  if (typeof document !== 'undefined' && current.name) {
    document.title = current.name;
  }
}

export function getProductInfo(): ProductInfo {
  return current;
}

/** Строка вида «ShbDeployer 1.4.7». */
export function fullVersion(info: ProductInfo = current): string {
  return info.version ? `${info.name} ${info.version}` : info.name;
}

/** Заголовок окна: «ShbDeployer · Раздел». */
export function pageTitle(section?: string): string {
  return section ? `${current.name} · ${section}` : current.name;
}
